var _desc, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrewedCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Brewed Coffee") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M19 32h26v14c0 8-8.191 12-8.191 12H27s-8-4-8-12V32zm26 2h2a6 6 0 0 1 0 12h-2",
    "data-name": "layer2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M37 28c0-12 12-14 12-26M27 28c0-6.125 6-8.9 6-14m25 46a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2 2 2 0 0 1 2-2h48a2 2 0 0 1 2 2z",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrewedCoffee);
export default __webpack_public_path__ + "static/media/brewed-coffee.1e0e33b3.svg";
export { ForwardRef as ReactComponent };